import React from 'react'
import { Task } from '@core/entities/task/Task'
import { Box, Collapse, LinearProgress } from '@mui/material'
import { TaskActivityWrapper } from '@modules/tasks/taskDetails/components/TaskActivity'
import { TransitionGroup } from 'react-transition-group'
import { useTaskActivities } from '@core/react-query/features/tasks/task/hooks/useTaskActivities'

type TaskActivityTabProps = {
  task: Task
  bgColor: string
  isModal: boolean
}

export const TaskActivityTab: React.FC<TaskActivityTabProps> = ({
  task,
  bgColor,
  isModal,
}) => {
  const { activityData, isFetching } = useTaskActivities({
    taskId: task?.id,
    fetchTask: !task,
  })

  return (
    <Box py={2}>
      {isFetching && <LinearProgress />}
      <TransitionGroup>
        {activityData?.map((activity, index) => (
          <Collapse key={index}>
            <TaskActivityWrapper
              key={index}
              activity={activity}
              task={task}
              bgColor={bgColor}
              isModal={isModal}
            />
          </Collapse>
        ))}
      </TransitionGroup>
    </Box>
  )
}
